import {HammerGestureConfig} from '@angular/platform-browser';
import {Injectable} from '@angular/core';

@Injectable()
export class HammerConfig extends HammerGestureConfig {
	public overrides = {
		pan: {
			enable: false,
		},
		rotate: {
			enable: false,
		},
		pinch: {
			enable: false,
		},
		swipe: {
			enable: true,
		},
	};
}
